<mat-dialog-content class="file-upload-dialog">
  <div class="dropzone" [class.active]="isDragging" (drop)="onDrop($event)" (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)" (click)="fileInput.click()">
    <input type="file" multiple #fileInput (change)="onFileSelected($event)" accept=".jpg,.jpeg,.png,.gif,.pdf,.docx"
      hidden>

    <div class="dropzone-content">
      <mat-icon>cloud_upload</mat-icon>
      <h3>Drag and drop files here</h3>
      <p class="file-types">Accepted file types: JPG, JPEG, PNG, GIF, PDF, DOCX</p>
      <p class="file-size">Accepted maximum file size: {{getFileMaxSize()}}</p>
    </div>
  </div>

  <div class="file-preview-container" *ngIf="files.length > 0">
    <h3>Selected Files ({{files.length}})</h3>
    <app-thumbnail [attachments]="files" (removeFile)="removeFile($event)" variant="large" ></app-thumbnail>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false">Cancel</button>
  <button mat-flat-button (click)="uploadFiles()" [disabled]="!files.length">
    Add Files
  </button>
</mat-dialog-actions>